module.exports = new __parcel__URL__("mother_wolf_statue_level_1.7673379b.png").toString();